import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { messageSectionAccess, sections } from "./shared";

export default function MessagesRoot() {
  return <Outlet />;
}

export function MessagesIndex() {
  const accesses = useSelector((state) => state.auth.accesses);
  const first = sections.find((section) => messageSectionAccess(accesses, section.alias)?.MenuHierarchyXGroup?.view);
  return first ? <Navigate to={first.path} replace /> : <p role="alert" className="h-full flex-1 bg-white p-4 text-sm">You do not have permission to view any Messages section.</p>;
}
